import React from 'react';
import Select from 'react-select';
import styles from '../Dataroom2.0/css/index.module.css';
import {
    SCOPE_SENTINEL,
    SELECT_STYLES,
    folderOptionsFromList,
    handleExclusiveSentinelChange,
    tagOptionsFromList,
    workstreamOptionsFromList,
} from '../../utils/aiWardenScope';

function ScopeSelect({ label, ...selectProps }) {
    return (
        <div className={styles.aiWardenFilterField}>
            <span className={styles.aiWardenMiniLabel}>{label}</span>
            <div className={styles.aiWardenSelectWrap}>
                <Select
                    className="basic-multi-select"
                    classNamePrefix="aiWardenSelect"
                    styles={SELECT_STYLES}
                    maxMenuHeight={220}
                    {...selectProps}
                />
            </div>
        </div>
    );
}

const AiWardenScopeFilters = ({
    workstreams = [],
    folders = [],
    irlTags = [],
    observationTags = [],
    selectedWorkstreams = [],
    selectedFolders = [],
    selectedIrlTags = [],
    selectedObsTags = [],
    onWorkstreamsChange,
    onFoldersChange,
    onIrlTagsChange,
    onObsTagsChange,
    disabled = false,
}) => {
    const wsOptions = [
        { label: 'Select all workstreams', value: SCOPE_SENTINEL.ALL },
        ...workstreamOptionsFromList(workstreams),
    ];
    const folderOpts = folderOptionsFromList(folders);
    const irlOpts = tagOptionsFromList(irlTags);
    const obsOpts = tagOptionsFromList(observationTags);

    return (
        <div className={styles.aiWardenScope}>
            <ScopeSelect
                label="Workstreams"
                isMulti
                closeMenuOnSelect={false}
                options={wsOptions}
                value={selectedWorkstreams}
                onChange={onWorkstreamsChange}
                placeholder="Select workstreams"
                isDisabled={disabled}
            />
            <ScopeSelect
                label="Folders"
                isMulti
                closeMenuOnSelect={false}
                options={folderOpts}
                value={selectedFolders}
                onChange={(selected, meta) =>
                    onFoldersChange?.(
                        handleExclusiveSentinelChange(selected, meta.option, [SCOPE_SENTINEL.ALL]),
                    )
                }
                placeholder="All folders"
                isDisabled={disabled}
            />
            <ScopeSelect
                label="IRL Tags"
                isMulti
                closeMenuOnSelect={false}
                options={irlOpts}
                value={selectedIrlTags}
                onChange={(selected, meta) =>
                    onIrlTagsChange?.(
                        handleExclusiveSentinelChange(selected, meta.option, [
                            SCOPE_SENTINEL.NONE,
                            SCOPE_SENTINEL.ALL,
                        ]),
                    )
                }
                placeholder="All tags"
                isDisabled={disabled}
            />
            <ScopeSelect
                label="Observation Tags"
                isMulti
                closeMenuOnSelect={false}
                options={obsOpts}
                value={selectedObsTags}
                onChange={(selected, meta) =>
                    onObsTagsChange?.(
                        handleExclusiveSentinelChange(selected, meta.option, [
                            SCOPE_SENTINEL.NONE,
                            SCOPE_SENTINEL.ALL,
                        ]),
                    )
                }
                placeholder="All tags"
                isDisabled={disabled}
            />
        </div>
    );
};

export default AiWardenScopeFilters;
